import React from "react";


function SvgVideo(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }



  return (
    <svg
      style={{ verticalAlign: "middle" }}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 249 249"
    >
      <g id="Group" transform="translate(-0.175 -0.476)">
        <rect
          id="bound"
          width={props.width}
          height={props.height}
          transform="translate(0.175 0.476)"
          fill="none"
        />
        <rect
          id="Combined_Shape"
          data-name="Combined Shape"
          width="135"
          height="125"
          rx="2"
          transform="translate(21.175 62.476)"
          fill={"#006bf6" + blur}
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M40.346,3.066A10.4,10.4,0,0,1,58.1,10.421v74.6a10.4,10.4,0,0,1-17.758,7.355l-37.3-37.3a10.4,10.4,0,0,1,0-14.711Z"
          transform="translate(170.743 77.105)"
          fill={"#006bf6" + blur}
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgVideo);
